import React from 'react';
import { motion } from 'framer-motion';
const learningPoints = [{
  number: '1',
  title: 'El Prompt Mágico',
  description: 'Fórmula exacta para que la IA entregue una página cara, no genérica.'
}, {
  number: '2',
  title: 'Diseño Sin Diseñar',
  description: 'Colores, tipografías y layout impecables sin Figma.'
}, {
  number: '3',
  title: 'Publícala Hoy',
  description: 'Conecta tu dominio y publica en vivo antes del fin del workshop.'
}, {
  number: '4',
  title: 'Copy que Vende',
  description: 'Las 5 secciones que toda página que convierte debe tener.'
}, {
  number: '5',
  title: 'Ediciones en Segundos',
  description: 'Cambia colores, textos, secciones con un solo comando.'
}, {
  number: '6',
  title: 'El Kit Secreto',
  description: 'Mis herramientas, prompts y los 3 errores del 95%.'
}];
export function WhatYouLearn() {
  return <section className="py-20 px-4 bg-violet-50" data-id="element-127">
      <div className="max-w-6xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-129">
          <h2 className="font-playfair text-4xl md:text-6xl font-bold text-gray-900 mb-16 text-center" data-id="element-130">
            Lo que Vas a Aprender en 90 Minutos
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-131">
            {learningPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-132">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-violet-600 text-white font-bold text-xl rounded-lg mb-4" data-id="element-133">
                  {point.number}
                </div>
                <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-3" data-id="element-134">
                  {point.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-135">
                  {point.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}